// Картинки для блока «Другие магазины» и страниц /store/:id
//
// Положите файлы в эту папку — имя = id магазина:
//   nintendo.png, steam.png, playstation.png, apple.png, xbox.png,
//   spotify.png, netflix.png, fortnite.png, roblox.png,
//   google-play.png, riot.png, pubg.png
//   xbox-game-pass.png, nintendo-membership.png
//
// Размер для дизайнера: 540×400 px (пропорция 1.35:1), PNG или WebP.
// Нижние ~30% на главной перекрывает название — важный контент выше.

const imageContext = require.context(".", false, /\.(png|webp|jpe?g)$/);

const VISORIA_STORE_IMAGES = {};

imageContext.keys().forEach((key) => {
  const id = key.replace("./", "").replace(/\.(png|webp|jpe?g)$/i, "");
  if (VISORIA_STORE_IMAGES[id] && !key.endsWith(".webp")) return;
  VISORIA_STORE_IMAGES[id] = imageContext(key);
});

export { VISORIA_STORE_IMAGES };
